/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2017 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/

import { LoadingSpinnerService } from "src/app/shared/components/loading-spinner/loading-spinner.service";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";

@Component({
  selector: "app-logout",
  templateUrl: "./logout.component.html",
  styleUrls: ["./logout.component.scss"],
})
export class LogoutComponent implements OnInit {
  constructor(
    private _loadingSpinner: LoadingSpinnerService,
    private _router: Router,
    private cookieService: CookieService
  ) {}

  ngOnInit() {
    console.log("----------->>>i m in logout");
    localStorage.removeItem("username");
    localStorage.removeItem("userDetails");
    localStorage.clear();
    sessionStorage.clear();
    this.cookieService.deleteAll();
    this.cookieService.delete("PearsonSSOSession");
    this._loadingSpinner.show();
    setTimeout(() => {
      this._loadingSpinner.hide();
      this._router.navigate(["login"]);
    }, 500);
  }
}
